import { render, staticRenderFns } from "./UpgradeDesc.vue?vue&type=template&id=2500e8e9&scoped=true&"
import script from "./UpgradeDesc.vue?vue&type=script&lang=js&"
export * from "./UpgradeDesc.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeDesc.vue?vue&type=style&index=0&id=2500e8e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500e8e9",
  null
  
)

export default component.exports